import TextField from '@mui/material/TextField'
import {Text} from '../1elements'
import InputMask from "react-input-mask"
import Box from '@mui/material/Box'

const fieldSx = theme => ({
      backgroundColor: theme.palette.quaternary.main,
  
      '& .MuiTextField-root': {
        marginTop: 0,
        width: '100%',
      },
      '& .MuiInputBase-input': {
        padding: '5px 13px',
        boxShadow: 'none',
        '&:focus': {
          boxShadow: `${theme.boxShadow} !important`
        },
        '&:hover': {
          boxShadow: `${theme.boxShadow} !important`
        }
      },
      '& .MuiInputBase-multiline': {
        padding: 0,
      },
      '& .MuiOutlinedInput-root': {
        border: `1px solid ${theme.palette.primary.main}`,
        color: theme.palette.primary.main
      },
      '& fieldset': {
        border: 'none'
      }
})

const PhoneField = ({disabled, hint, required, validation, value, onChange, rows, className}) => {
    const validationMessage = () => {
        return validation ? validation : ' ' // spacer
    }

    const updateValue = (e) => {
        onChange(e.target.value)
    }

    return(
        <Box className={className}>
            <Text type='fieldLabel'>Phone Number{required&&'*'} <span>{hint && `(${hint})`}</span></Text>
            <InputMask mask="999-999-9999" value={value} maskChar=" "  onChange={updateValue} disabled={disabled} >
                {(inputProps)=>(
                    <TextField {...inputProps} value={value} variant="outlined" error={Boolean(validation)}
                               helperText={validationMessage()} multiline={Boolean(rows)} rows={rows}
                               InputProps={inputProps} disabled={disabled} sx={fieldSx}/>
                )}
            </InputMask>
        </Box>
    )
}

export default PhoneField
